import { Empty, List, ListProps, Space } from 'antd';
import { t } from '@hefe/i18n';
import React from 'react';

export default function CustomList(props: ListProps<any>) {
  return (
    <List
      {...props}
      locale={{
        emptyText: (
          <Space direction="vertical">
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={t('information_texts.no_data')}
            />
          </Space>
        ),
      }}
    />
  );
}
